<template>
  <div class="card import_payments">
    <div class="import_payments__header">
      <h4 class="title">{{ translate('bank_payment.import.title') }}</h4>
    </div>
    <div class="import_payments__content">
      <button
          type="button"
          class="import_payments__file"
          :disabled="loading"
          @click="$refs.file.click()"
          @dragover.prevent
          @drop.prevent="select_file($event.dataTransfer.files[0])"
      >
        {{ file ? file.name : translate('bank_payment.import.file') }}
      </button>
      <input ref="file" type="file" accept=".pdf,application/pdf" v-show="false" :disabled="loading" @change="select_file($event.target.files[0]); $event.target.value = ''" />
      <p v-if="error" class="text-danger" role="alert">{{ error }}</p>
    </div>
    <div class="import_payments__button">
      <button type="button" class="btn btn-danger btn-fill btn-wd" :disabled="loading" @click="$emit('close')">
        {{ translate('close_modal') }}
      </button>
      <button type="button" class="btn btn-success btn-fill btn-wd" :disabled="!file || loading" @click="upload">
        {{ translate(loading ? 'bank_payment.import.loading' : 'bank_payment.import.upload') }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalImportBankPayments',
  data () {
    return {
      file: null,
      loading: false,
      error: ''
    }
  },
  methods: {
    select_file(file) {
      if (!file || this.loading) return
      this.file = null
      this.error = ''
      if (!/\.pdf$/i.test(file.name) || (file.type && file.type !== 'application/pdf')) {
        this.error = this.translate('bank_payment.import.pdf_only')
      } else if (!file.size) {
        this.error = this.translate('bank_payment.import.invalid_file')
      } else {
        this.file = file
      }
    },
    async upload() {
      if (!this.file || this.loading) return
      const formData = new FormData()
      formData.append('bank_code', 'avangard')
      formData.append('file', this.file)
      this.error = ''
      this.loading = true
      try {
        const response = await this.$http.v1.importBankPayments(formData)
        const result = response.data.data
        this.global_notify('info', this.translate('bank_payment.import.created') + ': ' + Number(result.created))
        this.$emit('update', result)
      } catch (error) {
        let message = 'failed'
        if (error.data?.errors?.bank_code) {
          message = 'unsupported_bank'
        } else if ([400, 413, 415, 422].includes(error.status)) {
          message = 'validation_error'
        }
        this.error = this.translate('bank_payment.import.' + message)
        const detail = error.data?.error?.message?.message || error.data?.error?.message || error.data?.message
        if (typeof detail === 'string') this.error = detail
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.import_payments{
  &__header{
    padding: 20px 10px 10px;
    .title{
      font-size: 22px;
      font-weight: 600;
      text-align: center;
    }
  }
  &__content{
    padding: 10px;
  }
  &__file{
    width: 100%;
    min-height: 120px;
    padding: 20px;
    border: 2px dashed lightgray;
    border-radius: 3px;
    background: transparent;
    overflow-wrap: anywhere;
    &:not(:disabled):hover{
      background: rgba(lightgray, .3);
    }
  }
  &__button{
    display: flex;
    justify-content: center;
    padding: 10px;
    .btn{
      margin: 0 5px;
    }
  }
}
</style>
